import { render } from "./SectionHeader.vue?vue&type=template&id=7c2239b0&scoped=true"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"

import "./SectionHeader.vue?vue&type=style&index=0&id=7c2239b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2239b0"]])

export default __exports__